const pages = ['home','about','hiw','stations','curriculum','register','contact','outdoor','shop'];

function showPage(id) {
  pages.forEach(p => {
    document.getElementById('page-' + p).classList.remove('active');
    const navEl = document.getElementById('nav-' + p);
    if (navEl) navEl.classList.remove('active');
  });

  document.getElementById('page-' + id).classList.add('active');
  const navEl = document.getElementById('nav-' + id);
  if (navEl) navEl.classList.add('active');

  window.scrollTo({ top: 0, behavior: 'instant' });
}

function showSkateForm() {
  showPage('register');
  setTimeout(function() {
    var btn = document.getElementById('skate-accordion-btn');
    if (btn && !btn.classList.contains('active')) toggleAccordion(btn);
    if (btn) btn.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, 50);
}

// Folder accordion toggle (photo galleries + shop collections)
function wsToggleAccordion(btn) {
  var expanded = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', String(!expanded));
  btn.nextElementSibling.classList.toggle('is-collapsed', expanded);
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ws-accordion__toggle').forEach(function (btn) {
    if (btn.getAttribute('aria-expanded') !== 'true') {
      btn.nextElementSibling.classList.add('is-collapsed');
    }
  });
});

// Registration accordion toggle (Forest School / Skate School panels)
function toggleAccordion(btn) {
  var body = btn.nextElementSibling;
  var isOpen = body.classList.contains('open');
  body.classList.toggle('open', !isOpen);
  btn.classList.toggle('active', !isOpen);
}

// Sibling discount — show/hide sibling section, seed first entry
function toggleSiblingFields(checkbox) {
  var container = document.getElementById('sibling_fields');
  if (checkbox.checked) {
    container.style.display = 'block';
    if (document.getElementById('sibling-list').children.length === 0) wsAddSibling();
  } else {
    container.style.display = 'none';
    document.getElementById('sibling-list').innerHTML = '';
  }
}

var WS_AGE_OPTIONS =
  '<option value="">Select age or grade\u2026</option>' +
  '<option>Preschool (Age 3)</option>' +
  '<option>PreK (Age 4)</option>' +
  '<option>Kindergarten (Age 5)</option>' +
  '<option>1st Grade (Age 6)</option>' +
  '<option>2nd Grade (Age 7)</option>' +
  '<option>3rd Grade (Ages 8\u20139)</option>';

function wsAddSibling() {
  var list = document.getElementById('sibling-list');
  var div = document.createElement('div');
  div.className = 'sibling-entry';
  div.innerHTML =
    '<div class="sibling-entry-header">' +
      '<strong class="sibling-label"></strong>' +
      '<button type="button" class="remove-sibling-btn" onclick="wsRemoveSibling(this)">\u2715 Remove</button>' +
    '</div>' +
    '<div class="form-group">' +
      '<label>First Name</label>' +
      '<input type="text" name="sibling_first_name" placeholder="First name">' +
    '</div>' +
    '<div class="form-group">' +
      '<label>Last Name</label>' +
      '<input type="text" name="sibling_last_name" placeholder="Last name">' +
    '</div>' +
    '<div class="form-group">' +
      '<label>Age / Grade</label>' +
      '<select name="sibling_age_grade">' + WS_AGE_OPTIONS + '</select>' +
    '</div>';
  list.appendChild(div);
  wsRenumberSiblings();
}

function wsRemoveSibling(btn) {
  var entry = btn.closest('.sibling-entry');
  entry.parentNode.removeChild(entry);
  wsRenumberSiblings();
  if (document.getElementById('sibling-list').children.length === 0) {
    var cb = document.getElementById('sibling_discount_check');
    if (cb) cb.checked = false;
    document.getElementById('sibling_fields').style.display = 'none';
  }
}

function wsRenumberSiblings() {
  document.querySelectorAll('#sibling-list .sibling-entry').forEach(function (entry, i) {
    var lbl = entry.querySelector('.sibling-label');
    if (lbl) lbl.textContent = 'Sibling ' + (i + 1);
  });
}

// ── Disable full workshops in the dropdown ────────────────────
var WS_ROSTER_URL = 'https://script.google.com/macros/s/AKfycbwyp6ZMQFd3Sl_Kh3FiU4YbS0DJA0d-gp02m0_ySNhEAS4izjiE5oWQ37h7itKNCVdSPw/exec';

document.addEventListener('DOMContentLoaded', function () {
  var workshopSelect = document.querySelector('[name="workshop"]');
  if (!workshopSelect) return;

  fetch(WS_ROSTER_URL + '?t=' + Date.now())
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var full = data.full || [];
      if (!full.length) return;

      Array.prototype.forEach.call(workshopSelect.options, function (opt) {
        if (full.indexOf(opt.value) !== -1) {
          opt.disabled = true;
          opt.text = opt.text + ' — FULL';
        }
      });
    })
    .catch(function () { /* silently ignore — form still usable */ });
});

// ── Forest School Registration ────────────────────────────────

document.addEventListener('DOMContentLoaded', function () {
  var forestForm = document.getElementById('forest-reg-form');
  if (forestForm) forestForm.addEventListener('submit', function (e) {
    e.preventDefault();
    wsSubmitForestReg(this);
  });

  var skateForm = document.getElementById('skate-reg-form');
  if (skateForm) skateForm.addEventListener('submit', function (e) {
    e.preventDefault();
    wsSubmitSkateReg(this);
  });

  // ── Package price display ────────────────────────────────────────
  var SK_BASE_PRICES = { personal: 75, mobile: 95, group: 50 };

  function skUpdatePriceDisplay() {
    var sessionEl = document.getElementById('sk-session-type');
    var packageEl = document.getElementById('sk-package');
    var displayEl = document.getElementById('sk-price-display');
    if (!sessionEl || !packageEl || !displayEl) return;
    var sessionVal = sessionEl.value;
    var pkgVal     = packageEl.value;
    if (!sessionVal || !pkgVal) { displayEl.textContent = ''; return; }
    var base = SK_BASE_PRICES[sessionVal] || 0;
    if (pkgVal === 'sub') {
      displayEl.textContent = '$' + base + ' / week — billed automatically each week, cancel anytime';
    } else {
      var numSessions = parseInt(pkgVal, 10);
      var total = base * numSessions;
      var label = numSessions === 1 ? 'Single session' : numSessions + ' sessions';
      displayEl.textContent = label + ' — $' + total + (numSessions > 1 ? ' total (paid upfront)' : '');
    }
  }

  var skSessionEl = document.getElementById('sk-session-type');
  var skPackageEl = document.getElementById('sk-package');
  if (skSessionEl) skSessionEl.addEventListener('change', skUpdatePriceDisplay);
  if (skPackageEl) skPackageEl.addEventListener('change', function () {
    skUpdatePriceDisplay();
    // Re-trigger date hint if a date is already selected
    var iso = document.getElementById('skate_date_iso') ? document.getElementById('skate_date_iso').value : '';
    if (iso) {
      var friendly = document.getElementById('skate_date').value;
      var pkgVal2  = this.value;
      var numPkg   = pkgVal2 === 'sub' ? 4 : parseInt(pkgVal2, 10);
      var isSub    = pkgVal2 === 'sub';
      if (numPkg > 1) {
        var hintDates = [friendly];
        for (var wi = 1; wi < numPkg; wi++) hintDates.push(skIsoToFriendly(skAddDays(iso, wi * 7)));
        var hintLabel = isSub ? 'Booking first month (' + numPkg + ' sessions): ' : 'Booking ' + numPkg + ' sessions: ';
        document.getElementById('sk-date-hint').textContent = hintLabel + hintDates.join(' \u00b7 ');
      } else {
        document.getElementById('sk-date-hint').textContent = 'Selected: ' + friendly;
      }
    }
  });

  // ── Skate School Availability Calendar ──────────────────────────
  var SK_MONTHS  = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var SK_DOW     = ['Su','Mo','Tu','We','Th','Fr','Sa'];
  var SK_DAYNAME = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

  var skCal = { year: 0, month: 0, bookedIso: [], selectedIso: null };

  // ── Pure-math date helpers — no Date API, no timezone bugs ──────
  // Day of week via Tomohiko Sakamoto's algorithm (0=Sun … 6=Sat)
  function skDayOfWeek(year, month, day) {
    var t = [0, 3, 2, 5, 0, 3, 5, 1, 4, 6, 2, 4];
    var m = month + 1; // convert to 1-indexed
    if (m < 3) year -= 1;
    return (year + Math.floor(year / 4) - Math.floor(year / 100) + Math.floor(year / 400) + t[m - 1] + day) % 7;
  }
  function skDaysInMonth(year, month) {
    var days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (month === 1 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0)) return 29;
    return days[month];
  }
  function skPad(n) { return n < 10 ? '0' + n : '' + n; }
  function skISO(year, month, day) { return year + '-' + skPad(month + 1) + '-' + skPad(day); }
  function skTodayISO() {
    var n = new Date();
    return skISO(n.getFullYear(), n.getMonth(), n.getDate());
  }

  function skCalRender() {
    var el = document.getElementById('sk-cal');
    if (!el) return;

    var todayISO       = skTodayISO();
    var startDow       = skDayOfWeek(skCal.year, skCal.month, 1);
    var daysInMonth    = skDaysInMonth(skCal.year, skCal.month);
    var isCurrentMonth = skISO(skCal.year, skCal.month, 1).slice(0, 7) === todayISO.slice(0, 7);

    var h = '<div class="sk-cal-head">';
    h += '<button type="button" class="sk-cal-nav" id="sk-prev"' + (isCurrentMonth ? ' disabled' : '') + '>&#8249;</button>';
    h += '<span>' + SK_MONTHS[skCal.month] + ' ' + skCal.year + '</span>';
    h += '<button type="button" class="sk-cal-nav" id="sk-next">&#8250;</button>';
    h += '</div><div class="sk-cal-grid">';

    SK_DOW.forEach(function(d) { h += '<div class="sk-cal-dow">' + d + '</div>'; });

    for (var i = 0; i < startDow; i++) h += '<div class="sk-cal-cell">\u00a0</div>';

    for (var day = 1; day <= daysInMonth; day++) {
      var iso       = skISO(skCal.year, skCal.month, day);
      var dow       = skDayOfWeek(skCal.year, skCal.month, day);
      var isWeekday = dow >= 1 && dow <= 5;
      var isPast    = iso < todayISO;
      var isBooked  = skCal.bookedIso.indexOf(iso) !== -1;
      var isSel     = skCal.selectedIso === iso;

      var cls = 'sk-cal-cell';
      var attr = '';

      if (isWeekday) {
        cls += ' sk-target';
        if (isPast)        { cls += ' sk-past'; }
        else if (isSel)    { cls += ' sk-selected'; attr = ' data-iso="' + iso + '"'; }
        else if (isBooked) { cls += ' sk-booked'; }
        else               { cls += ' sk-available'; attr = ' data-iso="' + iso + '"'; }
      }

      h += '<div class="' + cls + '"' + attr + '>' + day + '</div>';
    }

    var total = startDow + daysInMonth;
    var trail = (7 - (total % 7)) % 7;
    for (var j = 0; j < trail; j++) h += '<div class="sk-cal-cell">\u00a0</div>';

    h += '</div>';
    h += '<div class="sk-cal-legend">';
    h += '<div class="sk-cal-legend-item"><div class="sk-cal-legend-dot" style="background:#2d6a3f;border-radius:3px">\u00a0</div>Available</div>';
    h += '<div class="sk-cal-legend-item"><div class="sk-cal-legend-dot" style="background:#842029;border-radius:3px">\u00a0</div>Booked</div>';
    h += '</div>';

    el.innerHTML = h;

    var prevBtn = document.getElementById('sk-prev');
    var nextBtn = document.getElementById('sk-next');
    if (prevBtn && !prevBtn.disabled) prevBtn.addEventListener('click', function() {
      skCal.month--; if (skCal.month < 0) { skCal.month = 11; skCal.year--; } skCalRender();
    });
    if (nextBtn) nextBtn.addEventListener('click', function() {
      skCal.month++; if (skCal.month > 11) { skCal.month = 0; skCal.year++; } skCalRender();
    });

    el.querySelectorAll('[data-iso]').forEach(function(cell) {
      cell.addEventListener('click', function() {
        var iso      = this.getAttribute('data-iso');
        // Parse as UTC noon so toLocaleDateString gives correct local date
        var parts    = iso.split('-');
        var d        = new Date(Date.UTC(+parts[0], +parts[1] - 1, +parts[2], 12));
        var dayName  = SK_DAYNAME[d.getUTCDay()];
        var friendly = d.toLocaleDateString('en-US', { weekday:'long', month:'long', day:'numeric', year:'numeric', timeZone:'UTC' });
        skCal.selectedIso = iso;
        document.getElementById('skate_day').value      = dayName;
        document.getElementById('skate_date').value     = friendly;
        document.getElementById('skate_date_iso').value = iso;
        // Show all package dates in the hint
        var pkgEl   = document.getElementById('sk-package');
        var pkgVal3 = pkgEl ? pkgEl.value : '1';
        var isSub3  = pkgVal3 === 'sub';
        var numPkg  = isSub3 ? 4 : parseInt(pkgVal3, 10);
        if (numPkg > 1) {
          var hintDates = [friendly];
          for (var wi = 1; wi < numPkg; wi++) hintDates.push(skIsoToFriendly(skAddDays(iso, wi * 7)));
          var hintLabel = isSub3 ? 'Booking first month (' + numPkg + ' sessions): ' : 'Booking ' + numPkg + ' sessions: ';
          document.getElementById('sk-date-hint').textContent = hintLabel + hintDates.join(' \u00b7 ');
        } else {
          document.getElementById('sk-date-hint').textContent = 'Selected: ' + friendly;
        }
        skCalRender();
      });
    });
  }

  // Init calendar immediately on page load
  if (skateForm) {
    var now = new Date();
    skCal.year  = now.getFullYear();
    skCal.month = now.getMonth();
    var calEl   = document.getElementById('sk-cal');
    if (calEl) calEl.innerHTML = '<div style="padding:1.5rem;text-align:center;color:var(--text-muted);font-size:.9rem">Loading availability\u2026</div>';
    var availUrl = skateForm.dataset.availabilityUrl;
    if (availUrl) {
      fetch(availUrl, { method: 'GET' })
        .then(function(r) { return r.json(); })
        .then(function(data) { skCal.bookedIso = data.bookedDates || []; skCalRender(); })
        .catch(function() { skCal.bookedIso = []; skCalRender(); });
    } else {
      skCalRender();
    }
  }
});

function wsSubmitForestReg(form) {
  var btn = document.getElementById('fs-submit');
  var errEl = document.getElementById('fs-error');
  errEl.style.display = 'none';

  var studentVariant = form.dataset.studentVariant;
  var siblingVariant = form.dataset.siblingVariant;
  if (!studentVariant) {
    errEl.textContent = 'Checkout is not yet configured. Please contact us directly to register.';
    errEl.style.display = 'block';
    return;
  }

  // Collect checked days
  var days = [];
  form.querySelectorAll('[name="days"]:checked').forEach(function (cb) { days.push(cb.value); });

  var properties = {
    'Child Name': form.querySelector('[name="child_first_name"]').value + ' ' + form.querySelector('[name="child_last_name"]').value,
    'Age / Grade': form.querySelector('[name="age_grade"]').value,
    'Workshop': form.querySelector('[name="workshop"]').value,
    'Parent / Guardian': form.querySelector('[name="parent_name"]').value,
    'Email': form.querySelector('[name="email"]').value,
    'Phone': form.querySelector('[name="phone"]').value
  };

  var allergies = form.querySelector('[name="allergies_special_needs"]').value;
  if (allergies) properties['Allergies / Special Needs'] = allergies;

  var referral = form.querySelector('[name="referral"]').value;
  if (referral) properties['How they heard about us'] = referral;

  var notes = form.querySelector('[name="additional_notes"]').value;
  if (notes) properties['Notes'] = notes;

  // Collect all sibling entries
  var siblings = [];
  document.querySelectorAll('#sibling-list .sibling-entry').forEach(function (entry) {
    var first = entry.querySelector('[name="sibling_first_name"]').value.trim();
    var last  = entry.querySelector('[name="sibling_last_name"]').value.trim();
    var grade = entry.querySelector('[name="sibling_age_grade"]').value;
    var name  = (first + ' ' + last).trim();
    if (name) siblings.push(name + (grade ? ' \u2014 ' + grade : ''));
  });
  siblings.forEach(function (sib, i) {
    properties['Sibling ' + (i + 1)] = sib;
  });

  // Charge per selected day — both days = two separate line items
  var daysToCharge = days.length >= 2 ? days : [days[0] || 'Not specified'];
  var items = [];
  daysToCharge.forEach(function (day) {
    var dayProps = Object.assign({}, properties, { 'Preferred Days': day });
    items.push({ id: parseInt(studentVariant, 10), quantity: 1, properties: dayProps });
  });
  if (siblings.length > 0 && siblingVariant) {
    siblings.forEach(function () {
      daysToCharge.forEach(function () {
        items.push({ id: parseInt(siblingVariant, 10), quantity: 1 });
      });
    });
  }

  btn.disabled = true;
  btn.textContent = 'Adding to cart\u2026';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'] })
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      btn.disabled = false;
      btn.textContent = 'Submit Workshop Registration \u2192';
      if (data.status) {
        errEl.textContent = data.description || 'Something went wrong. Please try again.';
        errEl.style.display = 'block';
        return;
      }
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      } else {
        window.location.href = '/cart';
      }
      form.reset();
      document.getElementById('sibling_fields').style.display = 'none';
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = 'Submit Workshop Registration \u2192';
      errEl.textContent = 'Network error. Please try again.';
      errEl.style.display = 'block';
    });
}

// ── Skate date helpers (global so wsSubmitSkateReg can use them) ─
function skAddDays(iso, days) {
  var d = new Date(iso + 'T12:00:00Z');
  d.setUTCDate(d.getUTCDate() + days);
  var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
  return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
}
function skIsoToFriendly(iso) {
  var DAYS   = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var d = new Date(iso + 'T12:00:00Z');
  return DAYS[d.getUTCDay()] + ', ' + MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate() + ', ' + d.getUTCFullYear();
}

// ── Skate School Registration ────────────────────────────────

function wsSubmitSkateReg(form) {
  var btn = document.getElementById('sk-submit');
  var errEl = document.getElementById('sk-error');
  errEl.style.display = 'none';

  var sessionSelect = document.getElementById('sk-session-type');
  var sessionVal = sessionSelect ? sessionSelect.value : '';

  if (!sessionVal) {
    errEl.textContent = 'Please select a session type.';
    errEl.style.display = 'block';
    return;
  }

  var packageSelect  = document.getElementById('sk-package');
  var pkgVal         = packageSelect ? packageSelect.value : '1';
  var isSubscription = pkgVal === 'sub';
  var numSessions    = isSubscription ? 4 : parseInt(pkgVal, 10);

  var skateDateIsoCheck = form.querySelector('[name="skate_date_iso"]') ? form.querySelector('[name="skate_date_iso"]').value : '';
  if (!skateDateIsoCheck) {
    errEl.textContent = 'Please select a session date from the calendar.';
    errEl.style.display = 'block';
    return;
  }

  // Subscriptions use the single-session variant + a selling_plan ID
  var variantId;
  if (isSubscription) {
    var subVariantMap = { personal: form.dataset.personalVariant, mobile: form.dataset.mobileVariant, group: form.dataset.groupVariant };
    variantId = subVariantMap[sessionVal];
  } else {
    var variantMap = {
      'personal-1': form.dataset.personalVariant,
      'personal-2': form.getAttribute('data-personal-2wk-variant'),
      'personal-4': form.getAttribute('data-personal-4wk-variant'),
      'personal-8': form.getAttribute('data-personal-8wk-variant'),
      'mobile-1':   form.dataset.mobileVariant,
      'mobile-2':   form.getAttribute('data-mobile-2wk-variant'),
      'mobile-4':   form.getAttribute('data-mobile-4wk-variant'),
      'mobile-8':   form.getAttribute('data-mobile-8wk-variant'),
      'group-1':    form.dataset.groupVariant,
      'group-2':    form.getAttribute('data-group-2wk-variant'),
      'group-4':    form.getAttribute('data-group-4wk-variant'),
      'group-8':    form.getAttribute('data-group-8wk-variant')
    };
    variantId = variantMap[sessionVal + '-' + pkgVal];
  }

  if (!variantId) {
    errEl.textContent = 'Checkout is not yet configured. Please contact us directly to register.';
    errEl.style.display = 'block';
    return;
  }

  var sellingPlanId = form.dataset.sellingPlan || '';
  if (isSubscription && !sellingPlanId) {
    errEl.textContent = 'Subscription is not yet configured. Please contact us directly to register.';
    errEl.style.display = 'block';
    return;
  }

  var skateDay     = form.querySelector('[name="skate_day"]').value;
  var skateDate    = form.querySelector('[name="skate_date"]').value;
  var skateDateIso = form.querySelector('[name="skate_date_iso"]').value;

  var sessionLabel = sessionSelect.options[sessionSelect.selectedIndex].text;
  var packageLabel = isSubscription ? 'Weekly Subscription' : (numSessions === 1 ? 'Single Session' : numSessions + ' Weeks');

  var properties = {
    'Student Name':       form.querySelector('[name="skate_first_name"]').value + ' ' + form.querySelector('[name="skate_last_name"]').value,
    'Age':                form.querySelector('[name="skate_age"]').value,
    'Session Type':       sessionLabel,
    'Package':            packageLabel,
    'Number of Sessions': isSubscription ? 'Weekly (ongoing)' : String(numSessions),
    'Preferred Day':      skateDay || 'Not specified',
    'Session Date':       skateDate || 'Not specified',
    'Parent / Guardian':  form.querySelector('[name="skate_parent_name"]').value,
    'Email':              form.querySelector('[name="skate_email"]').value,
    'Phone':              form.querySelector('[name="skate_phone"]').value
  };

  var skateNotes = form.querySelector('[name="skate_notes"]').value;
  if (skateNotes) properties['Notes'] = skateNotes;

  btn.disabled = true;
  btn.textContent = 'Adding to cart\u2026';

  var cartItem = { id: parseInt(variantId, 10), quantity: 1, properties: properties };
  if (isSubscription) cartItem.selling_plan = parseInt(sellingPlanId, 10);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [cartItem], sections: ['cart-drawer', 'cart-icon-bubble'] })
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      btn.disabled = false;
      btn.textContent = 'Submit Skate School Registration \u2192';
      if (data.status) {
        errEl.textContent = data.description || 'Something went wrong. Please try again.';
        errEl.style.display = 'block';
        return;
      }
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      } else {
        window.location.href = '/cart';
      }
      form.reset();
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = 'Submit Skate School Registration \u2192';
      errEl.textContent = 'Network error. Please try again.';
      errEl.style.display = 'block';
    });
}
